module.exports = __webpack_public_path__ + "static/img/logo.dc5e5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/logo.png
// module id = aOfw
// module chunks = 15